export type TAction = 'create' | 'edit' | 'delete';
